import React, { useContext, useState } from "react"
import { Button, IconButton, Dialog, DialogTitle, Slide, DialogContent, Typography, TextField } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import useMutation from "../hooks/useMutation"
import UserContext from "../context/UserContext"

const MAX_LENGTH = 300

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const ContactFormDialog = ({ handleClose, onSend = () => null, text, placeholder }) => {
  const [msg, setMsg] = useState("")

  const { userData } = useContext(UserContext)
  const { email } = userData.user

  const { mutate, loading } = useMutation("/support")

  const handleSend = async () => {
    onSend()
    handleClose()

    await mutate({
      email,
      message: msg,
    })
  }

  return (
    <Dialog TransitionComponent={Transition} onClose={handleClose} open>
      <DialogTitle>
        Kontaktformular
        <IconButton sx={{ position: "absolute", right: "1vw", top: "1vh" }} onClick={handleClose}>
          <CloseIcon color="secondary" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>{text}</Typography>

        <TextField
          value={msg}
          disabled={loading}
          onChange={(e) => (e.target.value.length <= MAX_LENGTH ? setMsg(e.target.value) : null)}
          placeholder={placeholder}
          label="Anfrage"
          autoFocus
          multiline
          minRows={3}
          maxRows={5}
          fullWidth
          sx={{ mt: 2 }}
        />
        <Typography variant="caption" sx={{ mt: 0.5, display: "flex", justifyContent: "flex-end", color: "#777" }}>
          <i>
            {msg.length}/{MAX_LENGTH}
          </i>
        </Typography>
        <Typography variant="caption" sx={{ mt: 0.5, display: "flex", color: "#777" }}>
          Wir werden dir per Email an {email} antworten.
        </Typography>
        <Typography variant="caption" sx={{ mt: 0.5, mb: 2, display: "flex", color: "#777" }}>
          Du kannst uns auch direkt über support@bookay-buecher.de kontaktieren.
        </Typography>

        <Button variant="contained" fullWidth onClick={handleSend} disabled={msg.length <= 0 || loading}>
          Absenden
        </Button>
      </DialogContent>
    </Dialog>
  )
}

export default ContactFormDialog
